import { useEffect, useState } from "react";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Building2, ChevronDown, Check } from "lucide-react";
import { toast } from "sonner";

export default function TenantSwitcher() {
  const { user, switchTenant } = useAuth();
  const [tenants, setTenants] = useState([]);
  useEffect(() => {
    api.get("/tenant/my-tenants").then(({ data }) => setTenants(data)).catch(() => setTenants([]));
  }, [user?.id, user?.tenant_id]);
  const current = tenants.find((t) => t.id === user?.tenant_id);
  if (!current) return null;
  const choose = async (id) => {
    if (id === current.id) return;
    try { await switchTenant(id); window.location.reload(); }
    catch (error) { toast.error(formatError(error)); }
  };
  if (tenants.length < 2) return <span className="text-sm font-semibold">{current.name}</span>;
  return <DropdownMenu>
    <DropdownMenuTrigger asChild><Button variant="ghost" size="sm" className="gap-2" data-testid="tenant-switcher-trigger">
      <Building2 className="w-4 h-4" />{current.name}<ChevronDown className="w-3 h-3" />
    </Button></DropdownMenuTrigger>
    <DropdownMenuContent>{tenants.map((t) => <DropdownMenuItem key={t.id} onClick={() => choose(t.id)}>
      {t.name}{t.id === current.id && <Check className="w-4 h-4 ml-2" />}
    </DropdownMenuItem>)}</DropdownMenuContent>
  </DropdownMenu>;
}
